// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"186":"d13d41a9","292":"df73a911"}[chunkId] + ".chunk.css";
};